import { ROUTER_PATHS, hasPermission, useTableFilter, useTableServerSideFiltering } from '@/shared';
import { useFetchEgreso } from '@/shared/actions/erp/compras/Egreso.actions';
import {

  GeneralTable,
  SingleTableBoxScene,
} from '@/shared/components/ui';
import { Egreso } from '@/shared/interfaces';
import { Box, Grid, Tab, Tabs, Typography } from '@mui/material';
import { useTableColumnsEgreso } from './columnsEgreso';
import { ScrollableDialogProps } from '@/shared/components/ui/Dialogs';
import { PermissionsEnum } from '@/auth/interfaces';
import { useCargarSeriesProductos } from '@/store/erp/productos/useCargarSeriesProductos.store';
import SampleTablePagination from '@/shared/components/ui/SampleTablePagination';
import { useState } from 'react';
import TabReporteEgresos from '../ReporteEgresos/TabReporteEgresos';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ pt: 3 }}>{children}</Box>}
    </div>
  );
}

const EgresoPage = () => {
  const returnUrlEgreso = ROUTER_PATHS.inventario.egresos_nav;
  //********************** STORE
  const productos = useCargarSeriesProductos(s => s.productos)
  const paginatedData = useCargarSeriesProductos(s => s.paginatedData)
  const paginationTable = useCargarSeriesProductos(s => s.pagination)
  const setPaginationTable = useCargarSeriesProductos(s => s.setPagination)
  const clearSelectedItems = useCargarSeriesProductos(s => s.clearSelectedItems)
  //HOOK
  const { columnaBase, columnsProductosDetallePedidosDb, isModalOpen, setIsModalOpen } = useTableColumnsEgreso(/* { onRefetch:()=>{refetch()}} */);

  const { searchTerm, pagination, setPagination } = useTableFilter();

  const { pageIndex, pageSize } = pagination;

  const { columnFilters, setColumnFilters, filterObject } = useTableServerSideFiltering();
  //FETCH
  const {
    isLoading,
    data: egreso,
    isRefetching,
    //refetch
  } = useFetchEgreso({
    page: pageIndex + 1,
    page_size: pageSize,
    numero_referencia: searchTerm,
    ...filterObject,
    filterByState: false,
  });

  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  return (
    <>
      <Box sx={{ width: '100%' }}>
        {/* Título principal */}
        <Box sx={{ mb: 3, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Typography variant="h4" component="h1" sx={{ fontWeight: 600 }}>
            Egresos Inventario
          </Typography>
        </Box>

        {/* Tabs */}
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs value={tabValue} onChange={handleTabChange}>
            <Tab label="Proceso" id="tab-0" aria-controls="tabpanel-0" />
            <Tab label="Reporte" id="tab-1" aria-controls="tabpanel-1" />
          </Tabs>
        </Box>

        {/* Tab Panels */}
        <TabPanel value={tabValue} index={0}>
          <SingleTableBoxScene
            title=""
            urlRedirect={`${returnUrlEgreso}/crear`}
            enableRedirect={hasPermission(PermissionsEnum.api_add_egresoinventario)}
          >
            {/* <CustomSearch onChange={onChangeFilter} value={globalFilter} text="Egreso"  /> */}
            <Grid item xs={12}>
              <GeneralTable<Egreso>
                columns={columnaBase}
                data={egreso?.data.data || []}
                //
                isLoading={isLoading}
                isRefetching={isRefetching}
                // // search
                enableGlobalFilter={false}
                // onGlobalFilterChange={setGlobalFilter}
                // // pagination
                pagination={pagination}
                onPaging={setPagination}
                rowCount={egreso?.data.count}
                // // actions
                actionsColumnSize={120}
                ///
                enableManualFiltering={true}
                columnFilters={columnFilters}
                onColumnFiltersChange={setColumnFilters}
                enableSorting={false}
                // crud
                enableColumnActions={true}
                enableEditing={false}
                canDelete={false}
                positionActionsColumn='first'

              />
              <ScrollableDialogProps
                open={isModalOpen}
                title="📝 Productos"
                minWidth='70%'
                onCloseIcon={() => { setIsModalOpen(false), clearSelectedItems() }}
                contentNode={
                  <>
                    <Grid container spacing={3}>
                      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <SampleTablePagination
                          columns={columnsProductosDetallePedidosDb}
                          data={paginatedData}
                          rowCount={productos.length}
                          pagination={paginationTable}
                          setPagination={setPaginationTable}
                        />
                        {/* {details.length > 0 && (
                      <SampleTable<MaterialTransferido>
                        columns={columnsProductosDetallePedidosDb}
                        data={details}
                      />
                    )} */}
                      </Grid>
                    </Grid>
                  </>
                }
              />
            </Grid>
          </SingleTableBoxScene>
        </TabPanel>

        <TabPanel value={tabValue} index={1}>
          <TabReporteEgresos />
        </TabPanel>
      </Box>
    </>
  );
};

export default EgresoPage;
